export default {"src":"/_next/static/media/geographical-barrier.27b1fc39.svg","height":151,"width":151,"blurWidth":0,"blurHeight":0};